/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Once_HintInputs */

const vi_irrigation_run_once_hint = /** @type {(inputs: Irrigation_Run_Once_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bơm tự bật đúng giờ hẹn và tự tắt khi hết thời lượng.`)
};

/**

* @param {Irrigation_Run_Once_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_once_hint = /** @type {((inputs?: Irrigation_Run_Once_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Once_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_once_hint(inputs)
});